import { DiligenceUploadFailure } from './diligenceUploadFailure';

export function buildDiligenceUploadHeaders(size: number, contentType: string) {
  return {
    'Content-Type': contentType,
    'Content-Range': `bytes 0-${size - 1}/${size}`
  };
}

/** Uploads one complete file to a server-created Cloud Storage resumable session. */
export async function uploadDiligenceFile(uploadUrl: string, file: File, contentType: string) {
  let response: Response;
  try {
    response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: buildDiligenceUploadHeaders(file.size, contentType),
      body: file
    });
  } catch (cause) {
    throw new DiligenceUploadFailure('No se pudo transferir el documento.', {
      stage: 'transfer', errorKind: 'network_error', cause
    });
  }
  if (!response.ok) {
    throw new DiligenceUploadFailure('No se pudo transferir el documento.', {
      stage: 'transfer', errorKind: 'storage_upload_failed', status: response.status
    });
  }
}
